import { Form, FormControl, TextInput, Button, Alert } from 'callahan-react'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import SiteTable from './SiteTable'
import { fetchSiteInfo } from '../../actions/site-info-actions'
import BackButton from '../../components/BackButton'

import '../default.css'
import './site-info.css'

const propTypes = {
  isFetchingSiteInfo: PropTypes.bool,
  fetchSiteInfoError: PropTypes.bool,
  siteInfoData: PropTypes.object
}

const initialState = {
  domain: '',
  showValidation: false,
  showTable: false,
  showError: false
}

export class SiteInfo extends Component {
  constructor(props) {
    super(props)
    this.state = initialState
  }

  handleDomainChange = event => {
    const domain = event.target.value
    this.setState({ domain, showValidation: false })
  }

  validateDomain = () => {
    if (this.state.domain === '') {
      return { result: 'error', message: 'Domain must not be blank' }
    }
    return { result: 'success' }
  }

  // Submit form when user presses enter
  enterToSubmit = event => {
    if (event.which === 13) {
      this.submitForm()
      event.preventDefault()
    }
  }

  submitForm = () => {
    const { domain } = this.state
    if (domain === '') {
      this.setState({ showValidation: true })
      return
    }
    let query = new URLSearchParams()
    query.append('domain', domain)
    this.props.dispatch(fetchSiteInfo(query.toString())).then(() => {
      const { siteInfoData, fetchSiteInfoError } = this.props
      let showTable = siteInfoData && !fetchSiteInfoError
      this.setState({ showTable, showError: !showTable })
    })
  }

  resetPage = () => {
    this.setState(initialState)
  }

  render() {
    const { siteInfoData, isFetchingSiteInfo } = this.props
    const { showValidation, domain, showError, showTable } = this.state
    return (
      <div className="main-content">
        <div className="title-bar">
          <BackButton onClick={this.resetPage} />
          <h1 className="page-title">Site Info</h1>
          <div className="title-right-padding" />
        </div>
        <hr />
        <div className="ui-content">
          <Form className="ui-form" showValidation={showValidation}>
            <FormControl value={domain} label="Domain" validationMethod={this.validateDomain}>
              <div className="ui-form-wrapper">
                <TextInput
                  className="ui-input"
                  placeholder="example.com"
                  value={domain}
                  onChange={this.handleDomainChange}
                  onKeyPress={this.enterToSubmit}
                />
                <Button
                  buttonType="primary"
                  buttonMode="small"
                  className="ui-button"
                  onClick={this.submitForm}
                  loading={isFetchingSiteInfo}
                >
                  Search
                </Button>
              </div>
            </FormControl>
          </Form>
          {showError && (
            <Alert
              title={siteInfoData.status === 404 ? 'Domain not found' : siteInfoData.data.message}
              color={'error'}
              className="ui-error-alert"
            />
          )}
          {showTable && (
            <div className="ui-data">
              <SiteTable displayData={siteInfoData.data} />
            </div>
          )}
        </div>
      </div>
    )
  }
}

SiteInfo.propTypes = propTypes

function mapStateToProps(state) {
  const { siteInfo } = state
  return {
    isFetchingSiteInfo: siteInfo.isFetchingSiteInfo,
    fetchSiteInfoError: siteInfo.fetchSiteInfoError,
    siteInfoData: siteInfo.siteInfoData
  }
}

export default connect(mapStateToProps)(SiteInfo)



// WEBPACK FOOTER //
// ./src/pages/SiteInfo/SiteInfo.js